import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["arrowAtEdge"];
import React, { forwardRef } from "react";
import { TooltipFlyoutArrowStyled } from "../styled/TooltipFlyoutArrowStyled";
import { Arrows } from "./Arrows";
export var TooltipFlyoutArrow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var arrowAtEdge = _ref.arrowAtEdge,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(TooltipFlyoutArrowStyled, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(Arrows, {
    align: getAlign(props.placement, arrowAtEdge),
    color: props.backgroundColor,
    rotation: getRotation(props.placement)
  }));
});
TooltipFlyoutArrow.displayName = "TooltipFlyoutArrow";

// This is a mapping of {actual arrow placement}-{arrowAtEdge} => the kind of arrow alignment we
// should choose. Note that all the combinations are not listed here, only the ones that are
// actually possible. For example, you can't have a "top-top" or "top-bottom" arrow placement.
var arrowAlignLookup = {
  "top-left": "left",
  "top-right": "right",
  "left-top": "right",
  "left-bottom": "left",
  "right-top": "left",
  "right-bottom": "right",
  "bottom-left": "right",
  "bottom-right": "left"
};
function getAlign(placement, arrowAtEdge) {
  var _arrowAlignLookup$arr;
  var dir = placement.split("-")[0];
  var arrowKey = "".concat(dir, "-").concat(arrowAtEdge || "false");
  return (_arrowAlignLookup$arr = arrowAlignLookup[arrowKey]) !== null && _arrowAlignLookup$arr !== void 0 ? _arrowAlignLookup$arr : "center";
}
function getRotation(placement) {
  switch (placement) {
    case "top":
    case "top-start":
    case "top-end":
      return 0;
    case "right":
    case "right-start":
    case "right-end":
      return 90;
    case "bottom":
    case "bottom-start":
    case "bottom-end":
      return 180;
    case "left":
    case "left-start":
    case "left-end":
    default:
      return 270;
  }
}
//# sourceMappingURL=TooltipFlyoutArrow.js.map